<!-- Static “reached destination” row: not an expansion control -->
<div class="!m-0 max-w-full min-w-0 !rounded-none !shadow-none" [class]="direction">
  <div
    class="!bg-gray box-border !shadow-none !px-3 !h-20 flex w-full min-w-0 max-w-full items-center overflow-x-clip"
  >
    <div class="min-w-0 max-w-full flex-1 basis-0">
      <div
        class="flex max-w-full min-w-0 justify-between gap-2"
        (click)="focusLocationEvent.emit(section.arrival?.place?.location)"
      >
        <div class="flex min-w-0 flex-1 basis-0 items-center gap-2">
          <ng-icon
            name="location-dot"
            class="section-icon section-icon--last shrink-0 text-2xl text-white border-2 border-solid !border-green relative !bg-green p-2"
            style="border-radius: 50%"
          />

          <span class="flex flex-col gap-2 min-w-0">
            <span class="font-normal text-sm text-[#0C3058]">{{
              reachedDestinationText
            }}</span>
            <span class="break-words text-[#0C3058] !text-base">{{
              section.arrival.place.name ??
                formValues.destination.addressDetails.label
            }}</span>
          </span>
        </div>

        <span class="text-[#0C3058] shrink-0 tabular-nums">{{
          section.arrival.hourTimeString | hour
        }}</span>
      </div>
    </div>
  </div>
</div>
